import React, { useRef, useState } from 'react';
import { Sidebar } from 'primereact/sidebar';
import { useMutation } from '@tanstack/react-query';
import { patchEmailNotificationsEnabled } from '@/src/app/services/admin/UsersService';
import { Checkbox } from 'primereact/checkbox';
import ErrorToast, {
  showToast,
} from '@/src/app/components/messages/ErrorAlert';
import { Toast } from 'primereact/toast';
import { useRolesAccessContext } from '@/src/app/context/RolesAccessContext';
import Requests from './Requests';

type PreferencesDrilldownContainerProps = {
  visible: boolean;
  hideDrilldown: () => void;
};

const PreferencesDrilldownContainer = ({
  visible,
  hideDrilldown,
}: PreferencesDrilldownContainerProps) => {
  const { emailNotificationsEnabled, setEmailNotificationsEnabled } =
    useRolesAccessContext();
  const [localValue, setLocalValue] = useState<boolean>(
    emailNotificationsEnabled ?? true
  );
  const toast = useRef<Toast>(null);

  const updatePreference = useMutation({
    mutationFn: (value: boolean) => patchEmailNotificationsEnabled(value),
    onSuccess: (_, value) => {
      setEmailNotificationsEnabled(value);
      showToast(
        'success',
        toast,
        'User Preference Update',
        'The email notification was updated successfully!',
        3000
      );
    },
    onError: () => {
      setLocalValue((prev) => !prev);
      showToast(
        'error',
        toast,
        'User Preference Update',
        "The email notification preference couldn't be updated",
        3000
      );
    },
  });

  return (
    <Sidebar
      visible={visible}
      position="right"
      onHide={hideDrilldown}
      className="w-full max-w-550px"
    >
      <div className="blackText text-standard printBackground w-full max-w-1150px">
        <div className="mt-3 ml-3 capitalize text-28px font-bold w-fit drilldownHeader">
          User Account
        </div>
        <div className="my-4 ml-3">
          <div>
            <div className='font-bold text-22px mb-2'>Preferences</div>
            <div className="flex gap-2 align-items-center">
              <Checkbox
                inputId={'emailNotif'}
                checked={localValue}
                onChange={(e) => {
                  setLocalValue(e.checked);
                  updatePreference.mutate(e.checked);
                }}
                disabled={updatePreference.isPending}
              />
              <label
                htmlFor={'emailNotif'}
                className="ml-1 mr-3 blackText text-standard"
              >
                Receive Email Notifications
              </label>
            </div>
          </div>
          <div className='mt-3'>
            <Requests />
          </div>
        </div>
      </div>
      <ErrorToast toastRef={toast} />
    </Sidebar>
  );
};

export default PreferencesDrilldownContainer;
